// ===========================================
// Which /messages the conversation URL uses (roles 1b §5.15)
// ===========================================
// The VIEW the user is on decides it, not the login role: a staff member (a TEACHER login) reading
// the office inbox at /admin/messages must stay there when a conversation opens, not be moved to
// /teacher/messages. The login role is only the fallback for a path that names no view.

const VIEWS = ['admin', 'teacher', 'parent', 'student'] as const;
const BY_ROLE: Record<string, string> = { ADMIN: 'admin', TEACHER: 'teacher', PARENT: 'parent', STUDENT: 'student' };

/** `pathname` is `/<schoolSlug>/<view>/messages/...`; returns `/<view>/messages`. */
export function messagesBasePath(pathname: string, role: string | undefined): string {
  const section = pathname.split('/')[2];
  const view = (VIEWS as readonly string[]).includes(section) ? section : BY_ROLE[role ?? 'ADMIN'];
  return view ? `/${view}/messages` : '/messages';
}
